/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { UpgradeProfileItem } from 'ng/modules/items/factories';

export type TUpgradeProfileCollection = typeof UpgradeProfileCollection;
/**
 * @description UpgradeProfile collection
 * @author Dhanashree Tilak
 */
export class UpgradeProfileCollection extends Collection {
    public static ngDependencies = [
        UpgradeProfileItem,
    ];

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'upgradeprofile',
            windowElement: 'lazy-load',
            permissionName: AviPermissionResource.PERMISSION_UPGRADEPROFILE,
            ...args,
        };

        super(extendedArgs);
        this.itemClass_ = this.getNgDependency(UpgradeProfileItem);
    }
}
